import React from "react";
import { useSelector } from "react-redux";
import {
  deleteSessionPreference,
  getSessionPreferences,
} from "../../../redux/features/croSlice";
import GlobalDeleteDialog from "../../../components/mui/Dialogue/GlobalDeleteDialog";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import {
  deleteProduct,
  deleteVendor,
  getAllProducts,
  getAllVendors,
} from "../../../redux/features/assetManagementSlice";

const DeleteProduct = ({ id, data }) => {
  const { loading } = useSelector((state) => state.assetmanagement);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Product"}
      deleteNote={"Are you sure? you want to delete this product..?"}
      api={deleteProduct(id)}
      upDateCall={getAllProducts(data)}
      loading={loading}
    />
  );
};

export default DeleteProduct;
